// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-fluid {
  padding-top: 120px;
}

@media print {
  app-navbar {
    display: none;
  }
  #mainContainer {
    padding-top: 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AAEA;EACI;IACI,aAAA;EACN;EAEE;IACI,gBAAA;EAAN;AACF","sourcesContent":[".container-fluid{\n    padding-top: 120px\n}\n\n@media print {\n    app-navbar {\n        display: none;\n    }\n\n    #mainContainer {\n        padding-top: 0px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
